import {
  CertificationIndexResponse,
  CreateApiParam,
  SignatureGroupType,
} from "@sw-sw/lib-certification";
import xhrService from "../xhrService";
import db from '../../db/db';
import { baseUrl as baseInspectionUrl } from "./inspection";
import { getDateOnly } from "../date";
import { AxiosPromise } from "axios";

export type BulkCertifyParam = { id: number; date: string; lineType: string }[];


async function createOfflineCertification(inspectionId: number, group: string, data: any, resend?: boolean, online?: boolean) {
 

  const existingCertification= await db.certifications.get(inspectionId).catch((error: any) => {
    console.log('Error getting offline inspe  ction certifications', error);
  
  }
  );

  if(!existingCertification){
    return; 
  }

  const findings = await db.findings.where('inspection_id').equals(inspectionId).toArray().catch((error: any) => {
    console.log('Error getting offline inspection findings', error);
    return Promise.reject(error);
  })

  const user = await db.user.get(1).catch((error: any) => {
    console.log('Error getting offline user', error);
    return Promise.reject(error);
  }
  );

  if(!user){
    return Promise.reject('User not found');
  }

  const certId= Math.floor(Math.random() * 100000);
  const certObj={
    date: getDateOnly(data.date),
    email: user.email,
    imgSrc:'',
    lineType:data.lineType,
    signed_date: getDateOnly(new Date()),
    userName: user.name,
    userTitle:user.role,
    userId:user.user_id,
    id: certId, 
  }


  existingCertification.sync= {
    ...existingCertification.sync,
    synced:false,
    payload:[
      ...existingCertification.sync?.payload,
     {
      group: group,
      date: getDateOnly(data.date),
      lineType:data.lineType,
      emailMessage:data.emailMessage,
      default_message:data.default_message,
      resend:resend,
      id:certId
     }
    ]
  }

  if(online){
    existingCertification.sync.synced = true;
    existingCertification.sync.payload= [];
  }

   existingCertification.userSignatures[group].push(certObj);
  

  if(existingCertification.userSignatures[group].length === existingCertification.signatureGroups[group].length) {

    const field = group === SignatureGroupType.compliance ? 'compliance_date' : group === SignatureGroupType.acknowledgement ? 'acknowledgement_date': 'certification_date';

    if(group===SignatureGroupType.inspection)
    {
      await db.inspections.update(inspectionId,{status:'complete'})
    }
    
    if(group===SignatureGroupType.inspection &&  existingCertification.signatureGroups['acknowledgement'].length){
      existingCertification.groupOptions['acknowledgement'].enabled=true;
      existingCertification.groupOptions['acknowledgement'].errors=[]
     
    }

    if((group===SignatureGroupType.acknowledgement &&  existingCertification.signatureGroups['compliance'].length) ||
    (group === SignatureGroupType.inspection && existingCertification.signatureGroups['compliance'].length && existingCertification.signatureGroups['acknowledgement'].length===0)
    )
    {

     // console.log('Checking compliance findings for completion');

      const requiredFindings = findings?findings.filter((f: any) => f.is_required_for_cert):[];
      const completedRequiredFinings = requiredFindings.filter((f: any) => f.date_completed);
      const requiredFindingsCompleted = completedRequiredFinings.length === requiredFindings.length;

      // console.log('Required findings completed:', requiredFindingsCompleted);
      // console.log('Required findings:', requiredFindings);
      // console.log('Completed required findings:', completedRequiredFinings);
      // console.log('Existing certification:', existingCertification);

      if(!requiredFindingsCompleted){
        existingCertification.groupOptions['compliance'].enabled=false;
        existingCertification.groupOptions['compliance'].errors=['Findings need to be completed prior to signing'];
      }
      else{
      existingCertification.groupOptions['compliance'].enabled=true;
      existingCertification.groupOptions['compliance'].errors=[]  
      }
     
    }

    await db.inspections.update(inspectionId, {[field]:getDateOnly(new Date()) }).catch((error: any) => {
      console.log('Error saving offline inspection certifications', error);
      Promise.reject(error);
      
  });
}

  await db.certifications.update(inspectionId, existingCertification).catch((error: any) => {
    console.log('Error saving offline inspection certifications', error);
    Promise.reject(error);
  })

  return Promise.resolve();

}

export const certificationApi = {
  /**
   * @todo argument signatureLineId: string
   * @todo new api `${baseInspectionUrl}/${inspectionId}/signature/${signatureLineId}`
   */
  create: async ({ inspectionId, group, ...data }: CreateApiParam, resend?: boolean) => {
    const offline = navigator.onLine? false: true;
    
    if(!offline) {
    const certData= await xhrService.post<void>(
      `${baseInspectionUrl}/${inspectionId}/cert/${group}`,
      {data, resend},
    );
   await createOfflineCertification(inspectionId, group, data, resend,true) as unknown as AxiosPromise<void>;
    return certData;
  } else {

    return createOfflineCertification(inspectionId, group, data, resend,false) as unknown as AxiosPromise<void>;
  }
  },
  index: async(inspectionId: number) => {
    const offline = navigator.onLine? false: true;
    
    if(!offline) {
    return xhrService
      .get<CertificationIndexResponse>(`/api/inspections/${inspectionId}/cert`)
      .then(res => res.data);
    }
    else {
      
      const result:CertificationIndexResponse = await db.certifications.get(Number(inspectionId)).catch((error: any) => {
        console.log('Error getting offline inspection certifications', error);
        return [] 
      
      });
      return result;
    }
  },

  bulkCertify: (data: BulkCertifyParam) => {    
    return xhrService.post(
      `${baseInspectionUrl}/cert/${SignatureGroupType.compliance}`,
      data,
    );
  },

  bulkInspectionCertify: (data: BulkCertifyParam) => {    
    return xhrService.post(
      `${baseInspectionUrl}/cert/${SignatureGroupType.inspection}`,
      data,
    );
  },

  bulkAcknowledgementCertify: (data: BulkCertifyParam) => {    
    return xhrService.post(
      `${baseInspectionUrl}/cert/${SignatureGroupType.acknowledgement}`,
      data,
    );
  },

  getAllSignedCompliancesWithCount: (inspectionId: number) => {
    if(navigator.onLine){
    return xhrService.get(`/api/inspections/${inspectionId}/cert/allSignedCompliancesWithCount`)
    .then(res => res.data)
    }
    else {
      return db.certifications.get(inspectionId).then((certification: any) => {
        
        const signedCompliances = certification.userSignatures[SignatureGroupType.compliance].filter((signature: any) => signature.date);
        const signatures= signedCompliances.map((signature: any) => {
          return {
            ccrNumber:signature.ccrNumber,
            peNumber:signature.peNumber,
            signee_date:signature.signed_date,
            signee_name: signature.userName,
            signee_title: signature.userTitle,
            type: signature.lineType,
            email: signature.email
          }

        })

        return {
          rows:signatures,
          count: signedCompliances.length
        };
      }).catch((error: any) => {
        console.log('Error getting offline inspection certifications', error);
        return Promise.reject(error);
      }
      );
        
    }
  },

  removeCertification: (inspectionId: number, data: any) => {
    if(navigator.onLine) {
    return xhrService.post(`/api/inspections/${inspectionId}/removeCertification`, data)
    }
    else {
      return db.certifications.get(inspectionId).then((certification: any) => {
        if(!certification) {
          return Promise.reject('Certification not found');
        }
        
        const group = data.signatureGroup;
        const certIds=data.certIds || [];
        const userSignatures = certification.userSignatures[group];
        const updatedSignatures = userSignatures.filter((signature: any) => !certIds.includes(signature.id));

        certification.userSignatures[group] = updatedSignatures;
        certification.sync.payload = certification.sync.payload.filter((payload: any) => !certIds.includes(payload.id));
  
        return db.certifications.put(certification).then(() => {
          return Promise.resolve() as unknown as AxiosPromise<any>;
        });
      }).catch((error: any) => {
        console.log('Error removing offline inspection certification', error);
        return Promise.reject(error);
      });
    }
  }
};
